export default "__VITE_ASSET__35377357__"